import Fragrances from "../components/project/Fragrances";

function MyFragrances() {
  return <Fragrances></Fragrances>;
}

export default MyFragrances;
